import { useState, useEffect } from 'react'

import { useStep } from '../../hooks/use-step'
import { Step } from '../../utils/steps'
import { TitleAndText } from '../title-and-text/title-and-text'

export const MeetYourNewAICollaborators = () => {
  const { step: nextStep } = useStep()
  const [step, setStep] = useState(nextStep)
  useEffect(() => {
    if (nextStep === Step.GrammarlyOnly || nextStep === Step.FullBench) {
      setStep(nextStep)
    }
  }, [nextStep])

  return (
    <TitleAndText
      step={step}
      title="Meet your new AI collaborators"
      text="Superhuman Go is with you wherever you work, and it comes with a team of helpful AI agents, including the best Grammarly yet."
    />
  )
}
